import { memo, useCallback } from "react";

import { useNavigate } from "react-router-dom";

import PageHero from "src-next/shared/ui/sections/PageHero";
import { QuestionnaireManagementTabsPanelSection } from "src-next/modules/questionnaire-builder";
import { Box, Stack, Typography } from "@mui/material";
import { ListAlt, Settings } from "@mui/icons-material";
import { oids } from "@/configs/Settings";
import { PageHeader } from "@/components/common/PageHeader";
import { LargeContentBox } from "@/components/common";

/**
 * QuestionnaireManage — orquestrador (enxuto).
 *
 * Responsabilidades:
 * - Renderizar cabeçalho visual (PageHero).
 * - Delegar regra/IO do gerenciamento ao módulo `form-builder`.
 * - Controlar apenas navegação de UI (Editar via `useNavigate`).
 */
const QuestionnaireManage = memo(
  ({ organizationId }: { organizationId: string }) => {
    const navigate = useNavigate();

    const handleEditQuestionnaire = useCallback(
      (questionnaireId: string) => {
        // Mesmo padrão de outras telas MVP: contexto via `state` (ex.: navigate com state em useAppointmentActions).
        navigate("/questionnaireBuilder", {
          state: { questionnaireId, fromQuestionnaireManage: true },
        });
      },
      [navigate],
    );

    const handleCreateQuestionnaire = useCallback(() => {
      navigate("/questionnaireBuilder");
    }, [navigate]);

    return (
      <LargeContentBox>
        <Stack sx={{ width: "100%" }} spacing={3}>
          <PageHeader title="Gerenciar questionários" icon={Settings} />
          <QuestionnaireManagementTabsPanelSection
            organizationId={organizationId}
            onEditQuestionnaire={handleEditQuestionnaire}
            onCreateQuestionnaire={handleCreateQuestionnaire}
          />
        </Stack>
      </LargeContentBox>
    );
  },
);

QuestionnaireManage.displayName = "QuestionnaireManage";

export default QuestionnaireManage;
